export default __webpack_public_path__ + "locales/fr/Common.json?hash=0bdbf0f8facb6b886a9a6afad68c40dd";